<template>
  <d-card class="card-small">

    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ title }} {{ status[filter] }}</h6>
      <div class="block-handle"></div>
    </d-card-header>

    <d-card-body class="p-0">

      <!-- Top Referrals List Group -->
      <d-list-group flush class="list-group-small">
        <d-list-group-item v-for="(item, idx) in referralData" :key="idx" class="d-flex px-3">
          <d-link class="link" :to="{ name: 'admin-quotation-edit', params: { quotationId: item.id }}">
            <span class="text-semibold text-fiord-blue">{{ item.reference_no }} </span>
            <span class="text-semibold text-fiord-blue"> {{ item.customer_name }} </span>
          </d-link>
          <span class="ml-auto text-right text-semibold text-reagent-gray">{{ item.total }}</span>
        </d-list-group-item>
        <d-list-group-item v-if="referralData.length === 0"  class="d-flex px-3 no-content">
          Não houve nenhum resultado.
        </d-list-group-item>
      </d-list-group>

    </d-card-body>

    <d-card-footer class="border-top">
      <d-row>

        <!-- Time Frame -->
        <d-col>
          <d-select size="sm" v-model="filter" style="max-width: 150px;" :options="status" @change="getQuotations()">
          </d-select>
        </d-col>

        <!-- View Full Report -->
        <d-col class="text-right view-report">
          <d-link class="link" :to="{ name: 'admin-quotation-list', params: { page: 1 }}">Ver todos &rarr;</d-link>
        </d-col>

      </d-row>
    </d-card-footer>

  </d-card>
</template>

<script>
import DashboardService from '_services/rest/modules/dashboard';

export default {
  name: 'dashboard-last-quotation',
  data() {
    return {
      title: 'Lista de orçamentos por status',
      filter: 'pending',
      referralData: [],
      status: [
        { value: 'open', text: 'Rascunho' },
        { value: 'pending', text: 'Pendente' },
        { value: 'approved', text: 'Aprovado' },
        { value: 'canceled', text: 'Cancelado' },
        { value: 'closed', text: 'Concluído' },
      ],
    };
  },
  methods: {
    getQuotations() {
      setTimeout(() => {
        DashboardService.getQuotationsDashboard(this.filter, 'status')
          .then(response => {
            this.referralData = response.list;
          });
      }, 20);
    },
  },
  mounted() {
    this.getQuotations();
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  color: $primary;
  cursor: pointer;
}
</style>

